import React from "react";
import {
  Box,
  Typography,
  Paper,
  Button,
  Divider,
  Card,
  CardContent,
  Link
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import ViewListIcon from '@mui/icons-material/ViewList';

export default function CampagneSucces() {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Récupérer les informations de la campagne depuis l'état de navigation
  const campaignId = location.state?.campaignId || 'ID indisponible';
  const campaignName = location.state?.campaignName || 'Nouvelle campagne';
  const message = location.state?.message || 'Campagne créée avec succès!';

  return (
    <Box display="flex" flexDirection="column" alignItems="center" minHeight="90vh" bgcolor="#f8f9fa" p={4}>
      <Paper elevation={3} sx={{ width: '100%', maxWidth: 800, p: 4, borderRadius: 3, textAlign: 'center' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 4 }}>
          <CheckCircleIcon sx={{ fontSize: 80, color: '#4caf50', mb: 2 }} />
          <Typography variant="h4" fontWeight={700} color="#212529" fontFamily="Montserrat, Arial, sans-serif">
            Campagne créée avec succès!
          </Typography>
          <Typography variant="h6" color="#6c757d" mt={1} fontFamily="Montserrat, Arial, sans-serif">
            {campaignName}
          </Typography>
        </Box>

        <Divider sx={{ my: 3 }} />

        <Card sx={{ mb: 4, backgroundColor: '#f1f8e9', border: '1px solid #c5e1a5' }}>
          <CardContent>
            <Typography variant="body1" fontFamily="Montserrat, Arial, sans-serif">
              {message}
            </Typography>
            <Typography variant="body2" color="#6c757d" mt={2} fontFamily="Montserrat, Arial, sans-serif">
              Identifiant de campagne: <strong>{campaignId}</strong>
            </Typography>
          </CardContent>
        </Card>

        

        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
          <Button
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate(-1)}
            sx={{ borderRadius: 2, fontWeight: 600, fontFamily: "Montserrat, Arial, sans-serif" }}
          >
            Retour
          </Button>
          <Button
            variant="contained"
            color="primary"
            startIcon={<FormatListBulletedIcon />}
            onClick={() => navigate('/campagne')}
            sx={{ borderRadius: 2, fontWeight: 600, fontFamily: "Montserrat, Arial, sans-serif" }}
          >
            Liste des campagnes
          </Button>
          {process.env.REACT_APP_MAUTIC_URL && (
            <Button
              variant="contained"
              color="secondary"
              startIcon={<ViewListIcon />}
              component={Link}
              href={`${process.env.REACT_APP_MAUTIC_URL}/s/campaigns/view/${campaignId}`}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ borderRadius: 2, fontWeight: 600, fontFamily: "Montserrat, Arial, sans-serif" }}
            >
              Voir dans Mautic
            </Button>
          )}
        </Box>
      </Paper>
    </Box>
  );
} 